import React from 'react'
import { compose } from 'recompose'
import PropTypes from 'prop-types'
import { StyledSummaryDiv } from './styles'

const UpdateDetailRenderer = ({ data }) => (
  <StyledSummaryDiv
    dangerouslySetInnerHTML={{ __html: data.summary }}
    style={{ textAlign: 'left' }}
  />
)

UpdateDetailRenderer.propTypes = { data: PropTypes.object.isRequired }

UpdateDetailRenderer.defaultProps = {}

const UpdateDetailComponent = compose()(UpdateDetailRenderer)

export default UpdateDetailComponent
